import styled from 'styled-components/macro';

export const AdvancedOptionsLink = styled.a`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 100%;
  color: #0076C0;
  cursor: pointer;
  margin-top: 18px;
`;

export const ArrowContainer = styled.span`
  padding: 0 6px;
`;

export const Box = styled.div`
  background: #FFFFFF;
  border: 1px solid #D1D1D1;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 14px;
  margin-bottom: 6px;
`;

export const BoxTitleWrapper = styled.div`
  display: flex;
  margin-bottom: 18px;
`;

export const BoxTitle = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #444444;
  padding-right: 5px;
`;

export const BoxSubTitle = styled(BoxTitle)`
  font-size: 12px;
  line-height: 24px;
  padding: 0;
`;

export const BoxRequired = styled(BoxSubTitle)`
  color: #DC0D0D;
`;

export const Container = styled.div`
  padding: 20px;
  background-color: #E8EDF2;
`;

export const OptionsContainer = styled.div`
  padding-top: 18px;
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #006F93;
`;
